// src/modules/Courier/pages/RouteLists/RouteLists.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Base/Auth/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import api from '../../../services/api';
import styles from './RouteLists.module.css';

// Фетч маршрутов — api.get возвращает response.data
const fetchRoutes = () => api.get('/routes/my');

// Считаем прогресс доставки
const getProgress = (receipts = []) => {
  const total = receipts.length;
  const delivered = receipts.filter(r => r.status === 'Закрыта').length;
  const inProgress = receipts.filter(r => r.status === 'Открыта').length;
  const undelivered = receipts.filter(r => r.status === 'Не доставлено').length;
  return { delivered, inProgress, undelivered, total };
};

export default function RouteLists() {
  const navigate = useNavigate();
  const { token } = useAuth();

  const {
    data: routes = [],
    error,
    isLoading
  } = useQuery({
    queryKey: ['myRoutes', token],
    queryFn: fetchRoutes,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });

  const handleRouteClick = id => navigate(`/Courier/routes/${id}`);

  if (isLoading) {
    return (
      <div className={styles.loaderWrapper}>
        <h1>Загрузка маршрутных листов...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorWrapper}>
        <p className={styles.error}>{error instanceof Error ? error.message : String(error)}</p>
      </div>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <header>
        <h1 className={styles.pageTitleRed}>Маршрутные Листы</h1>
      </header>

      {routes.length === 0 ? (
        <p className={styles.noRoutes}>Нет доступных маршрутных листов</p>
      ) : (
        routes.map(route => {
          const { delivered, inProgress, undelivered, total } = getProgress(route.receipts);
          const dW = total ? (delivered / total) * 100 : 0;
          const iW = total ? (inProgress / total) * 100 : 0;
          const uW = total ? (undelivered / total) * 100 : 0;

          return (
            <div
              key={route.id}
              className={styles.mainBlock}
              onClick={() => handleRouteClick(route.id)}
            >
              <h2 className={styles.number}>Маршрут №{route.route_number}</h2>
              <p><strong>Дата:</strong> {new Date(route.route_date).toLocaleDateString()}</p>
              <p><strong>Районы:</strong> {route.route_districts}</p>
              <p><strong>Водитель:</strong> {route.driver}</p>
              <p><strong>Оператор:</strong> {route.operator}</p>
              <span className={styles.deliveredCount}>{delivered}/{total} Доставлено</span>

              <div className={styles.progressContainer}>
                <div className={styles.progressBar}>
                  <div className={styles.progressDelivered} style={{ width: `${dW}%` }} />
                  <div className={styles.progressInProgress} style={{ width: `${iW}%` }} />
                  <div className={styles.progressUndelivered} style={{ width: `${uW}%` }} />
                </div>
              </div>

              <div className={styles.statusContainer}>
                <div className={styles.statusItem}>
                  <span>Доставлено</span>
                  <span>{delivered}</span>
                </div>
                <div className={styles.statusItem}>
                  <span>В пути</span>
                  <span>{inProgress}</span>
                </div>
                <div className={styles.statusItem}>
                  <span>Не доставлено</span>
                  <span>{undelivered}</span>
                </div>
              </div>
            </div>
          );
        })
      )}

      <div className={styles.bottomSpacing}></div>
    </div>
  );
}
